<template>
  <div id="app">

    <div class="sticky-nav px-4">

    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
      <h1 class="h2">Customers</h1>
    </div>

    <div class="dropdown">
      <button class="btn btn-dark dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        Actions
      </button>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <a class="dropdown-item" v-on:click="modalNewCustomer()"><i class="fas fa-pencil-alt"></i> New</a>
        <a class="dropdown-item" v-on:click="modalEditCustomer()"><i class="fas fa-pencil-alt"></i> Edit</a>
        <a class="dropdown-item" v-on:click="delProducts()" href="#"><i class="fas fa-trash"></i> Delete</a>
      </div>
    </div>

    <button type="button" class="btn btn-primary" v-on:click="modalImport()"> Import</button>

    </div>

    <br /><br />

    <vue-good-table v-if="customers && customers.length "
          class="mb-3 px-4"
          @on-selected-rows-change="selectionChanged"
          @on-cell-click="onRowClick"
          :columns="customerColumns"
          :rows="customers"
          :pagination-options="{
            enabled: true,
            mode: 'pages',
            perPage: 100,
            position: 'bottom',
            perPageDropdown: [25, 50, 100],
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
            dropdownAllowAll: true,
          }"
          :selectOptions="{
            enabled: true,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, // disable the select info panel on top
          }"
    />

    <!-- Modal -->
    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Add grouped product</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="tab-content" id="nav-tabContent2">
              <div class="tab-pane fade show active pt-3" id="nav-new" role="tabpanel" aria-labelledby="nav-new-tab">
                <input type="text" class="form-control" v-model="addNewGroupedProduct.an" placeholder="Article N°" />
                <input type="text" class="form-control" v-model="addNewGroupedProduct.name" placeholder="Name" />
                <input type="text" class="form-control" v-model="addNewGroupedProduct.color" placeholder="Color" />
                <input type="text" class="form-control" v-model="addNewGroupedProduct.trade" placeholder="Trade" />
                <input type="text" class="form-control" v-model="addNewGroupedProduct.retail" placeholder="Retail" />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" v-on:click="saveGroupedProduct()">Save changes</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="editCustomerModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ editModalTitle }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <nav>
              <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true">Klant</a>
                <a class="nav-item nav-link" id="nav-category-tab" data-toggle="tab" href="#nav-category" role="tab" aria-controls="nav-category" aria-selected="false">Contacten</a>
                <a class="nav-item nav-link" id="nav-attributes-tab" data-toggle="tab" href="#nav-attributes" role="tab" aria-controls="nav-attributes" aria-selected="false">Adressen</a>
              </div>
            </nav>
            <div class="tab-content" id="nav-tabContent">
              <div class="tab-pane fade show active pt-3" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
                <label>Klantnummer</label><input type="text" class="form-control" v-model="editCustomer.customer_id" placeholder="Klantnummer" />
                <label>Bedrijf</label><input type="text" class="form-control" v-model="editCustomer.name" placeholder="Bedrijf" />
                <label>Straat</label><input type="text" class="form-control" v-model="editCustomer.straat" placeholder="Straat" />
                <label>Huisnummer</label><input type="text" class="form-control" v-model="editCustomer.huisnummer" placeholder="Huisnummer" />
                <label>Postcode</label><input type="text" class="form-control" v-model="editCustomer.postcode" placeholder="Postcode" />
                <label>Stad</label><input type="text" class="form-control" v-model="editCustomer.stad" placeholder="Stad" />
                <label>Land</label><input type="text" class="form-control" v-model="editCustomer.land" placeholder="Land" />
                <label>BTW</label><input type="text" class="form-control" v-model="editCustomer.btw" placeholder="BTW" />
                <label>Email</label><input type="text" class="form-control" v-model="editCustomer.email" placeholder="Email" />
              </div>
              <div class="tab-pane fade pt-3" id="nav-category" role="tabpanel" aria-labelledby="nav-category-tab">

                <div v-if="editCustomer.contacten.length > 0">
                  <div v-for="(contact) in editCustomer.contacten" v-bind:key="contact.id">
                    <label>Voornaam</label><input type="text" class="form-control" v-model="contact.voornaam" />
                    <label>Naam</label><input type="text" class="form-control" v-model="contact.naam" />
                    <label>Email</label><input type="text" class="form-control" v-model="contact.email" />
                    <hr>
                  </div>
                </div>

              </div>
              <div class="tab-pane fade pt-3" id="nav-attributes" role="tabpanel" aria-labelledby="nav-attributes-tab">

                <div v-if="editCustomer.adressen.length > 0">
                  <div v-for="(adres) in editCustomer.adressen" v-bind:key="adres.id">
                    <label>Bedrijf</label><input type="text" class="form-control" v-model="adres.name" placeholder="Name" />
                    <label>Straat</label><input type="text" class="form-control" v-model="adres.straat" placeholder="Trade" />
                    <label>Huisnummer</label><input type="text" class="form-control" v-model="adres.huisnummer" placeholder="Retail" />
                    <label>Postcode</label><input type="text" class="form-control" v-model="adres.postcode" placeholder="Tax" />
                    <label>Stad</label><input type="text" class="form-control" v-model="adres.stad" placeholder="Stad" />
                    <label>Land</label><input type="text" class="form-control" v-model="adres.land" placeholder="Land" />
                    <hr>
                  </div>
                </div>

              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" v-on:click="sCustomer(editCustomer.id)">Save changes</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <div class="modal fade" id="newCustomerModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">New customer</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <nav>
              <div class="nav nav-tabs" id="nav-tab" role="tablist">
                <a class="nav-item nav-link active" id="nav-new-home-tab" data-toggle="tab" href="#nav-new-home" role="tab" aria-controls="nav-new-home" aria-selected="true">Klant</a>
                <a class="nav-item nav-link" id="nav-new-category-tab" data-toggle="tab" href="#nav-new-category" role="tab" aria-controls="nav-new-category" aria-selected="false">Contacten</a>
                <a class="nav-item nav-link" id="nav-new-attributes-tab" data-toggle="tab" href="#nav-new-attributes" role="tab" aria-controls="nav-new-attributes" aria-selected="false">Adressen</a>
              </div>
            </nav>
            <div class="tab-content" id="nav-tabContent">
              <div class="tab-pane fade show active pt-3" id="nav-new-home" role="tabpanel" aria-labelledby="nav-new-home-tab">
                <label>Klantnummer</label><input type="text" class="form-control" v-model="editCustomer.customer_id" placeholder="Klantnummer" />
                <label>Bedrijf</label><input type="text" class="form-control" v-model="editCustomer.name" placeholder="Bedrijf" />
                <label>Straat</label><input type="text" class="form-control" v-model="editCustomer.straat" placeholder="Straat" />
                <label>Huisnummer</label><input type="text" class="form-control" v-model="editCustomer.huisnummer" placeholder="Huisnummer" />
                <label>Postcode</label><input type="text" class="form-control" v-model="editCustomer.postcode" placeholder="Postcode" />
                <label>Stad</label><input type="text" class="form-control" v-model="editCustomer.stad" placeholder="Stad" />
                <label>Land</label><input type="text" class="form-control" v-model="editCustomer.land" placeholder="Land" />
                <label>BTW</label><input type="text" class="form-control" v-model="editCustomer.btw" placeholder="BTW" />
                <label>Email</label><input type="text" class="form-control" v-model="editCustomer.email" placeholder="Email" />
              </div>
              <div class="tab-pane fade pt-3" id="nav-new-category" role="tabpanel" aria-labelledby="nav-new-category-tab">

              </div>
              <div class="tab-pane fade pt-3" id="nav-new-attributes" role="tabpanel" aria-labelledby="nav-new-attributes-tab">

              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-primary" v-on:click="createCustomer()">Save</button>
          </div>
        </div>
      </div>
    </div>


    <!-- Modal -->
    <div class="modal fade" id="importModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Import customers (.csv)</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="alert alert-warning" role="alert">
              - Gebruik "," als afscheidingsteken in het .csv bestand
            </div>
            <div class="input-group mb-1 fullw">
              <div class="custom-file fullw">
                <input type="file" ref="file" class="custom-file-input" v-on:change="handleFileUpload()" id="inputGroupFile02">
                <label class="custom-file-label" for="inputGroupFile02" aria-describedby="inputGroupFileAddon02">Choose file</label>
              </div>
              <select class="fullw mt-2 custom-select" v-model="importCategory" :required="true">
                <option :value="-1" disabled="true">- Select type -</option>
                <option
                 v-for="(type, idx) in types"
                 v-bind:key="idx"
                 v-bind:value="type.name"
                >{{ type.name }}</option>
              </select>
              <select class="fullw mt-2 custom-select" v-model="importType" :required="true">
                <option :value="-1" disabled="true">- Select import type -</option>
                <option value="new">New</option>
                <option value="update">Update</option>
                <option value="combo">New + Update</option>
              </select>
            </div>
            <div class="input-group p-1">
              {{ importFeedback }}
            </div>
            <div class="input-group p-1">
              <form id="frmImport">
              <div v-for="(key) in csvKeys" v-bind:key="key" class="match-wrapper">
                <input disabled="disabled" class="form-control" type="text" :value="key"/>
                <select :name="key" class="custom-select">
                  <option :value="-1">- Select column -</option>
                  <option v-for="(sql, id) in sqlKeys" :value="id" v-bind:key="sql" :selected="sql == key">{{ sql }}</option>
                </select>
              </div>
              </form>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" v-on:click="closeImport()">Close</button>
            <button type="button" class="btn" :class="readyForImport ? 'btn-secondary' : 'btn-primary'" v-on:click="uploadCSV">Upload</button>
            <button type="button" class="btn" :class="readyForImport ? 'btn-primary' : 'btn-secondary'" v-on:click="importCSV" :disabled="readyForImport ? false : true">{{ importStatus }}</button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import $ from 'jquery';
import 'bootstrap';
import axios from 'axios';

export default {
  name: 'app',
  components: {

  },
  data() {
    return{
      importType : '-1',
      importCategory: '-1',
      types: [
        {
          name: 'Klanten'
        },
        {
          name: 'Contacten'
        },
        {
          name: 'Leveradressen'
        }
      ],
      editModalTitle: '',
      groupedproducts: null,
      groupedproduct: null,
      groupedproductid: 1,
      customers: null,
      test: null,
      inputgroupedproductid: null,
      customersSelected: [],
      groupedProductSelected: null,
      updateGroupedProduct: {
          value: '',
          text: ''
      },
      addNewGroupedProduct: {
        name:'',
        an: '',
        color: ''
      },
      selectAll: false,
      file: '',
      editGroupedProduct: {
        id: '',
        name: '',
        use: '',
        collection: '',
        price: '',
        manufacturer: ''
      },
      editCustomer: {
        contacten: [],
        adressen: []
      },
      editCustomers: {
        attributes: [],
        related: []
      },
      importFeedback: '',
      csvKeys: '',
      editType: '',
      sqlKeys: '',
      readyForImport: false,
      importStatus: 'Import',
      groupPos: -1,
      autoGroupStatus: '',
      autoGroupList: [],
      autoGroupListItem: [],
      autoGroupListItemsSelected: [],
      gpOptions: {},
      autoGroupProps: {
        trade: '',
        retail: '',
        manufacturer: '',
        color: '',
        size: '',
        name: '',
        an: ''
      },
      customerColumns: [
        {label: 'Klantnummer', field: 'customer_id', filterOptions: {enabled: true}},
        {label: 'Bedrijf', field: 'name', filterOptions: {enabled: true}},
        {label: 'Adres', field: this.adresFn, filterOptions: {enabled: true}},
        {label: 'Land', field: 'land', filterOptions: {enabled: true}},
        {label: 'BTW', field: 'btw', filterOptions: {enabled: true}},
        {label: 'Email', field: 'email', filterOptions: {enabled: true}}
      ],
      attrPos: 0
    }
  },
  mounted (){
    this.getCustomers();
  },
  methods: {
    adresFn(rowObj){
      return rowObj.straat + ' ' + rowObj.huisnummer + ", " + rowObj.postcode + " " + rowObj.stad;
    },
    delProducts(){
      var products = this.customersSelected;
      axios
        .post('https://wrc.weblion.be/api/delete-products.php/',
          {
            products: products,
          })
        .then((response) => {
          console.log(response.data);
          this.getProducts();
        })
    },
    closeImport(){
      this.importType = '-1';
      this.importCategory = '-1';
      this.csvKeys = '';
      this.sqlKeys = '';
      this.importFeedback = '';
      $("#importModal").modal('hide');
    },
    closeAutoGroup(){
      $("#autoGroupModal").modal('hide');
      this.groupPos = '-1';
    },
    skipAutoGroup(){
      this.nextGroup();
    },
    saveAutoGroup(){

      axios
        .post('https://wrc.weblion.be/api/save_auto_group.php',{
          props: this.autoGroupProps,
          products : this.autoGroupListItemsSelected
        })
        .then((res)=>{
          console.log(res);
          this.nextGroup();
        })
    },
    nextGroup(){

      function allEqual(arr) {
        return new Set(arr).size == 1;
      }

      if((this.groupPos + 1) < this.autoGroupList.length){

        this.groupPos += 1;
        this.autoGroupListItem = this.autoGroupList[this.groupPos];
        this.autoGroupStatus = (this.groupPos + 1) + ' of ' + this.autoGroupList.length;

        var retail = []; var trade = []; var color = []; var manufacturer = [];

        this.autoGroupListItem.forEach(function(item){
          retail.push(item['retail']);
          trade.push(item['trade']);
          color.push(item['color']);
          manufacturer.push(item['manufacturer']);
        });

        if(allEqual(retail)){
          this.autoGroupProps.retail = this.autoGroupListItem[0].retail;
        }else{
          this.autoGroupProps.retail = null;
        }

        if(allEqual(trade)){
          this.autoGroupProps.trade = this.autoGroupListItem[0].trade;
        }else{
          this.autoGroupProps.trade = null;
        }

        if(allEqual(color)){
          this.autoGroupProps.color = this.autoGroupListItem[0].color;
        }else{
          this.autoGroupProps.color = null;
        }

        if(allEqual(manufacturer)){
          this.autoGroupProps.manufacturer = this.autoGroupListItem[0].manufacturer;
        }else{
          this.autoGroupProps.manufacturer = null;
        }


        var i; var j;
        var name = '';
        var an = '';
        var arr2 = [];

        for(i = 0; i < this.autoGroupListItem[0].name.length; i++){
          arr2 = [];

          for(j = 0; j < this.autoGroupListItem.length; j++){
            arr2.push(this.autoGroupListItem[j].name.charAt(i));
          }

          if(arr2.every( (val, i, arr) => val === arr[0] )){
            name += arr2[0];
          }
        }

        for(i = 0; i < this.autoGroupListItem[0].an.length; i++){
          arr2 = [];

          for(j = 0; j < this.autoGroupListItem.length; j++){
            arr2.push(this.autoGroupListItem[j].an.charAt(i));
          }

          if(arr2.every( (val, i, arr) => val === arr[0] )){
            an += arr2[0];
          }else{
            an += 'x';
          }
        }

        this.autoGroupProps.name = name.trim();
        this.autoGroupProps.an = an;

        this.autoGroupListItemsSelected = [];

        this.autoGroupListItem.forEach(item => {
          this.autoGroupListItemsSelected.push(item['an']);
        });

      }else{
        this.closeAutoGroup();
      }

    },
    autoGroup(){
      axios
        .get('https://wrc.weblion.be/api/auto_group_products.php')
        .then((res)=>{
          this.autoGroupList = res.data;
          this.autoGroupListItem = this.autoGroupList[this.groupPos];
          this.autoGroupStatus = (this.groupPos + 1) + ' of ' + this.autoGroupList.length;
          this.nextGroup();
          $("#autoGroupModal").modal('show');
          console.log(this.autoGroupProps);
          console.log(this.autoGroupListItemsSelected);
        })
    },
    saveGroupedProduct(){

      axios
        .post('https://wrc.weblion.be/api/save_grouped_product.php', {
            products: this.customersSelected,
            new: this.addNewGroupedProduct
        })
        .then(
          axios
          .get('https://wrc.weblion.be/api/products/')
          .then(response => {
            this.products = response.data;
            $("#exampleModal").modal('hide');
            this.getProducts();
          })
        )

    },
    getCustomers(){
      //Object.freeze(this.products);
      axios
        .get('https://wrc.weblion.be/api/customers/')
        .then(response => {
          this.customers = response.data;
          console.log(this.customers);
        })
    },
    handleFileUpload(){
      this.file = this.$refs.file.files[0];
      if(this.file.type != 'text/csv'){
        this.importFeedback = "Error: please upload a .csv file"
      }else{
        this.importFeedback = "Success: " + this.file.name + " is ready for upload";
      }
    },
    uploadCSV(){

      if(this.importType != '-1' && this.importCategory != '-1' && this.file != ''){
        let formData = new FormData();
        formData.append('file', this.file);

        axios.post('https://wrc.weblion.be/api/sql-customers.php',{
          'type' : this.importCategory
        })
        .then( (response) => {

          console.log(response.data);

          this.sqlKeys = response.data;

          console.log(this.sqlKeys);

          return axios.post('https://wrc.weblion.be/api/csv-customers.php',formData,
            {
              headers: { 'Content-Type': 'multipart/form-data' }
            })

        })
        .then( (response) => {
          this.importFeedback = "Please match .csv columns to database.";
          this.csvKeys = response.data;
          this.readyForImport = true;
        })
      }

    },
    importCSV(){

      this.importStatus = 'Importing...'

      let formData = new FormData();
      let match = JSON.stringify($("#frmImport").serializeArray());
      let sql = JSON.stringify(this.sqlKeys);
      let csv = JSON.stringify(this.csvKeys);

      formData.append('file', this.file);
      formData.append('sql', sql);
      formData.append('match', match );
      formData.append('csv', csv);
      formData.append('category', this.importCategory);
      formData.append('type', this.importType);

      axios
        .post('https://wrc.weblion.be/api/import-csv-customers.php', formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' }
          }
        )
      .then(response => {
        console.log(response);
        this.importStatus = 'Import';
        this.closeImport();
        this.getCustomers();
      })
    },
    onRowClick(table){
      //console.log(table.row.contacten);
      this.editModalTitle = 'Edit customer';
      this.editCustomer = table.row;
      this.editCustomer.contacten = table.row.contacten;
      this.editCustomer.adressen = table.row.adressen;

      $("#editCustomerModal").modal('show');
    },
    selectionChanged(table){
      this.customersSelected = table.selectedRows;
    },
    modalNewCustomer(){
      this.editModalTitle = 'New customer';
      this.editCustomer = {
        btw: '',
        email: '',
        name: '',
        land: '',
        postcode: '',
        stad: '',
        straat: '',
        customer_id: '',
        huisnummer: '',
        contacten: {
          voornaam: '',
          naam: '',
          email: ''
        },
        adressen: []
      };
      $("#newCustomerModal").modal('show');
    },
    modalEditCustomer(){

      if(this.customersSelected.length == 1){
        this.editCustomer = this.customersSelected[0];
        this.editModalTitle = 'Edit customer';
      }else if(this.customersSelected.length > 1){
        this.editCustomer = [];
        this.editModalTitle = 'Edit customers';
      }

      if(this.customersSelected.length > 0){
        var id = this.editCustomer.id;
        axios
          .post('https://wrc.weblion.be/api/attributes.php',
            {
              id: id
            })
          .then((response) => {
            this.$set(this.editCustomer, 'attributes', response.data);
          })
          .then(() => {
            axios
            .get('https://wrc.weblion.be/api/categories.php')
            .then((response) => {
              this.$set(this.editCustomer, 'categories', response.data);
            })
            .then(() => {
              $("#editCustomerModal").modal('show');
            })
          })
      }
    },
    modalImport(){
      axios
      .get('https://wrc.weblion.be/api/categories.php')
      .then((response) => {
        this.categories = response.data;
        $("#importModal").modal('show');
      })
    },
    modalGroupProducts(){

      function allEqual(arr) {
        return new Set(arr).size == 1;
      }

      var retail = []; var trade = []; var color = []; var name = [];

      this.customersSelected.forEach(function(item){
        retail.push(item['retail']);
        trade.push(item['trade']);
        color.push(item['color']);
        name.push(item['name']);
      });

      if(allEqual(retail)){
        this.addNewGroupedProduct.retail = this.customersSelected[0].retail;
      }else{
        this.addNewGroupedProduct.retail = null;
      }

      if(allEqual(name)){
        this.addNewGroupedProduct.name = this.customersSelected[0].name;
      }else{
        this.addNewGroupedProduct.name = null;
      }

      if(allEqual(trade)){
        this.addNewGroupedProduct.trade = this.customersSelected[0].trade;
      }else{
        this.addNewGroupedProduct.trade = null;
      }

      if(allEqual(color)){
        this.addNewGroupedProduct.color = this.customersSelected[0].color;
      }else{
        this.addNewGroupedProduct.color = null;
      }

      var i; var j;
      var g_name = '';
      var g_an = '';
      var arr2 = [];

      for(i = 0; i < this.customersSelected[0].name.length; i++){
        arr2 = [];

        for(j = 0; j < this.customersSelected.length; j++){
          arr2.push(this.customersSelected[j].name.charAt(i));
        }

        if(arr2.every( (val, i, arr) => val === arr[0] )){
          g_name += arr2[0];
        }
      }

      for(i = 0; i < this.customersSelected[0].an.length; i++){
        arr2 = [];

        for(j = 0; j < this.customersSelected.length; j++){
          arr2.push(this.customersSelected[j].an.charAt(i));
        }

        if(arr2.every( (val, i, arr) => val === arr[0] )){
          g_an += arr2[0];
        }else{
          g_an += 'x';
        }
      }

      this.addNewGroupedProduct.name = g_name.trim();
      this.addNewGroupedProduct.an = g_an;

      axios
        .get('https://wrc.weblion.be/api/grouped-products/')
        .then((response) => {
          this.groupedproducts = response.data;
          $("#exampleModal").modal('show');
        })
    },
    sCustomer(){

      axios
        .post('https://wrc.weblion.be/api/customers/update.php',{
          customer : this.editCustomer
        })
        .then((res) => {
          console.log(res);
          this.getCustomers();
        })
        .then(function(){ $("#editCustomerModal").modal('hide'); })

    },
    createCustomer(){

      axios
        .post('https://wrc.weblion.be/api/customers/create.php',{
          customer : this.editCustomer
        })
        .then((res) => {
          console.log(res);
          this.getCustomers();
        })
        .then(function(){ $("#newCustomerModal").modal('hide'); })

    }


  }
}
</script>

<style>
button{
  margin-right: 10px;
}
.table thead th{
  text-align: left !important;
}
.pager ul{
  list-style-type: none;
}
.pager ul li{
  display: inline-block;
  border: 1px solid #dee2e6;
  border-radius: 3px;
  padding: 5px;
  width: 40px;
  text-align: center;
  margin: 2px;
}
.modal input{
  margin-bottom: 5px;
}
.modal-body label{
  display: inline-block;
  width: 32%;
}

.modal-body .form-control{
  display: inline-block;
  width: 68%;
}

.modal-body select{
  text-indent: 5px;
}

#exampleModal input{
  display: block;
  width: 100%;
}

#importModal .modal-body label{
  width: auto;
}

#importModal input, #importModal select{
  display: inline-block;
  width: 49%;
  margin-bottom: 5px;
}

#importModal .match-wrapper, #importModal form{
  width: 100%;
}
#importModal select{
  margin-left: 1%;
}

#importModal .fullw{
  display: block;
  width: 100%;
  border-radius: 4px;
}

#importModal .fullw select{
  margin: 0;
}

#importModal .fullw input{
  display: block;
  width: 100%;
  margin: 0;
}

.dropdown{
  display: inline-block;
}
.dropdown-item:hover{
  cursor: pointer !important;
}
.dropdown-item i{
  margin-right:3px;
}
@media (min-width: 576px){
  .modal-dialog {
      max-width: 550px;
      margin: 1.75rem auto;
  }
}
.groupedState{
  display: inline-block;
  border-radius: 50%;
  width: 12px;
  height: 12px;
  margin-left: 25%;
}

#autoGroupModal table tr td{
  padding: 2px 10px;
}

#autoGroupModal .modal-title span{
  color: #777;
  font-size: 14px;
  margin-left: 10px;
}

#autoGroupModal input{
  width: 100%;
}

#autoGroupModal .form-check-input{
  width: auto;
  position: relative;
  margin: 0;
  vertical-align: 2px;
}

.ck.ck-editor {
    display: inline-block !important;
    width: 68% !important;
    margin-bottom: 5px !important;
}

.sticky-nav{
  position: fixed;
    height: 150px;
    top: 50;
    z-index: 2;
    background: white;
    padding-top: 10px;
        width: 100%;
        margin-top: -10px;
}

#editCustomerModal textarea{
  height: 100px;
}

.vgt-wrap{
  margin-top: 120px;
}

label{
  vertical-align: top;
}

[data-g='1']{
  background: #8CC040;
}

[data-g='0']{
  background: red;
}
</style>
